/**
 * Expert directory for the dev portal: one fetch of /eng/smes shared by every list that shows an
 * expert's picture next to a task. Cached for the lifetime of the page load; the list changes rarely.
 */
import { useMemo } from 'react'
import { api } from '@/api/client'
import { useAsync } from '@/components/useAsync'
import type { SmeSummary } from './types'

let cache: Promise<SmeSummary[]> | null = null

export function useSmeDirectory(): Record<string, SmeSummary> {
  const { data } = useAsync(() => (cache ??= api.get<{ smes: SmeSummary[] }>('/eng/smes').then((r) => r.smes).catch((e) => { cache = null; throw e })))
  return useMemo(() => Object.fromEntries((data ?? []).map((u) => [u.user_id, u])), [data])
}
